import React from 'react';
import { toastError, toastSuccess } from 'bench-internal-theme';
import { useClient } from '../../ClientContext';
import { showServerError } from 'bk-web-app';
import { GET_CONNECTIONS, UPDATE_USAGE_TYPE } from '../queries';
import { Select } from 'bench-internal-theme';
import { Account, UsageType } from '../types';
import useV2Mutation from 'utils/useV2Mutation';

type UsageTypeSelectContainerProps = {
  account: Account;
};

const UsageTypeSelect = ({ account }: UsageTypeSelectContainerProps) => {
  const { id: clientId } = useClient();

  const options = [
    { label: 'Business', value: UsageType[UsageType.BUSINESS] },
    { label: 'Personal', value: UsageType[UsageType.PERSONAL] },
    { label: 'Personal Used For Business', value: UsageType[UsageType.PERSONAL_USED_FOR_BUSINESS] },
  ];

  const [updateAccountType, { loading }] = useV2Mutation(UPDATE_USAGE_TYPE, {
    onCompleted: () => {
      toastSuccess('Account', 'Your usage type has been updated.');
    },
    onError: error => {
      toastError('An error occurred updating the usage type.', showServerError(error));
    },
    refetchQueries: [{ query: GET_CONNECTIONS, variables: { clientId } }],
  });

  const onChange = option =>
    updateAccountType({
      variables: {
        input: {
          ids: [account.id],
          clientUsageType: option.value,
        },
      },
    });

  return (
    <Select
      aria-label="Usage Type"
      value={options.find(option => option.value === account?.clientUsageType)}
      defaultValue={options.find(option => option.value === account?.clientUsageType)}
      onChange={onChange}
      isDisabled={loading}
      isSearchable={false}
      name="usageType"
      options={options}
      placeholder="Select..."
    />
  );
};

export default UsageTypeSelect;
